import React, { useState } from "react";
import {
  FaRobot,
  FaWhatsapp,
  FaEnvelope,
  FaArrowLeft,
  FaTimes,
  FaPaperPlane,
} from "react-icons/fa";
import { PiFlagCheckeredBold } from "react-icons/pi";
import { BsGlobeEuropeAfrica } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import "../styles/menuModal.css";

const ALLOXA_ORIGIN = "https://api.alloxa.ai";
const ALLOXA_PUBLIC_KEY = "d2fc13a16c5c9e2cfebf7b23";

export default function MenuModal({ onClose }) {
  const { t } = useTranslation();
  const [askAi, setAskAi] = useState(false);
  const [input, setInput] = useState("");
  const [threadId, setThreadId] = useState(null);
  const [messages, setMessages] = useState([
    { from: "ai", text: t("menu.defaultAi") },
  ]);
  const [loading, setLoading] = useState(false);

  const changeLanguage = (lng) => i18n.changeLanguage(lng);

  const handleSend = async () => {
    const trimmed = input.trim();
    if (!trimmed) return;

    setMessages((prev) => [...prev, { from: "user", text: trimmed }]);
    setInput("");
    setLoading(true);

    try {
      const body = {
        publicKey: ALLOXA_PUBLIC_KEY,
        message: trimmed,
        messageType: "text",
      };
      if (threadId) {
        body.threadId = threadId;
      }

      const res = await fetch(`${ALLOXA_ORIGIN}/api/public/webchat/send`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await res.json();
      if (data?.threadId) {
        setThreadId(data.threadId);
      }

      const aiReply =
        data?.reply ||
        data?.result ||
        data?.message ||
        data?.text ||
        t("menu.defaultAi");

      setMessages((prev) => [
        ...prev,
        { from: "ai", text: aiReply },
      ]);
    } catch (err) {
      setMessages((prev) => [...prev, { from: "ai", text: t("menu.error") }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="menu-fixed-wrapper">
      <div className={`menu-box ${askAi ? "chat-open" : "menu-open"}`}>
        {!askAi && (
          <button className="menu-close" onClick={onClose}>
            <FaTimes />
          </button>
        )}

        {askAi ? (
          <div className="ai-box">
            <div className="ai-box-header">
              <button className="ai-back" onClick={() => setAskAi(false)}>
                <FaArrowLeft /> {t("menu.back")}
              </button>
              <div className="ai-title-wrap">
                <span className="ai-title">{t("menu.assistantTitle")}</span>
                <a
                  className="ai-powered-by"
                  href="https://alloxa.ai"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("menu.poweredBy")}
                </a>
              </div>
              <button className="menu-close small" onClick={onClose}>
                <FaTimes />
              </button>
            </div>

            <div className="ai-message-box">
              {messages.map((msg, i) => (
                <div key={i} className={`ai-message ${msg.from}`}>
                  {msg.text}
                </div>
              ))}
              {loading && (
                <div className="ai-message ai">{t("menu.typing")}</div>
              )}
            </div>

            <div className="ai-input-area">
              <input
                type="text"
                placeholder={t("menu.placeholder")}
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
              />
              <button onClick={handleSend}>
                <FaPaperPlane />
              </button>
            </div>
          </div>
        ) : (
          <>
            <h2 className="menu-title">{t("menu.title")}</h2>
            <p className="menu-desc">{t("menu.desc")}</p>

            <div className="menu-actions">
              <button className="menu-btn brand" onClick={() => setAskAi(true)}>
                <FaRobot /> {t("menu.ask")}
              </button>
              <a
                className="menu-btn green"
                href="https://wa.me/38346192921"
                target="_blank"
                rel="noreferrer"
              >
                <FaWhatsapp /> {t("menu.whatsapp")}
              </a>
              <a className="menu-btn gray" href="mailto:info@example.com">
                <FaEnvelope /> {t("menu.sendEmail")}
              </a>
            </div>

            <div className="menu-language">
              <p>{t("menu.changeLanguage")}</p>
              <div className="lang-options">
                <button onClick={() => changeLanguage("en")}>
                  <BsGlobeEuropeAfrica /> EN
                </button>
                <button onClick={() => changeLanguage("sq")}>
                  <PiFlagCheckeredBold /> SQ
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
